import { localEnvironment, productionEnvironment } from "constants/globals";

//#region Navigation
export const DASHBOARD = "dashboard";
export const PLAN = "plan";
export const MAINTENANCE = "maintenance";
export const TASKS = "tasks";
//#endregion Navigation

//#region API
export const baseUrlApplicat =
  process.env.REACT_APP_ENV == productionEnvironment
    ? "https://applicat-api.tanguay.ca/scripts/wsb.wsc/applicatweb/rest/"
    : "https://applicat-api-dev.tanguay.ca/scripts/wsb.wsc/applicatweb/rest/";
export const baseUrlWarehouse = baseUrlApplicat + "entrepot/";

export const login = "user/authenticate";
export const SGE_MODULE = "modules=sge";
export const userPreferences = "userPreferences";
export const VALIDATION_URL = "user/validation";
export const RENEW_URL = "user/renew";

export const sge = "sge/";
export const ELEMENT_URL = "element";
export const STATUS_URL = "etat";
export const WAREHOUSE_LIST_URL = "location";
export const LOCALISATION_URL = "localisation";
export const ACTION_URL = "action";
export const NOTIFICATION_URL = "notification";
//#endregion API
